// Human-readable elapsed time in French, evolving from seconds to years.
export function timeAgo(ts) {
  if (!ts) return "—";
  const s = Math.max(1, Math.floor((Date.now() - new Date(ts).getTime()) / 1000));
  if (s < 60) return `Il y a ${s} seconde${s > 1 ? "s" : ""}`;
  const m = Math.floor(s / 60);
  if (m < 60) return `Il y a ${m} minute${m > 1 ? "s" : ""}`;
  const h = Math.floor(m / 60);
  if (h < 24) return `Il y a ${h} heure${h > 1 ? "s" : ""}`;
  const d = Math.floor(h / 24);
  if (d < 7) return `Il y a ${d} jour${d > 1 ? "s" : ""}`;
  const w = Math.floor(d / 7);
  if (w < 5) return `Il y a ${w} semaine${w > 1 ? "s" : ""}`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `Il y a ${mo} mois`;
  const y = Math.floor(d / 365);
  return `Il y a ${y} an${y > 1 ? "s" : ""}`;
}
